import { usePage } from '@inertiajs/react';
import React from 'react';
import { useLocationUpdates } from '../../hooks/useLocationUpdates';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import LocationGrid from './LocationGrid';
import LocationHeader from './LocationHeader';

export default function Index() {
  const { props } = usePage();

  // Usar hook para atualizações em tempo real
  const { locations, connectionStatus, lastUpdate, isRealTimeEnabled } = useLocationUpdates(
    props.locations
  );

  return (
    <DriveSyncLayout>
      <LocationHeader />
      <LocationGrid
        locations={locations}
        maps={props.maps}
        defaultLocation={props.default_location}
        connectionStatus={connectionStatus}
        lastUpdate={lastUpdate}
        isRealTimeEnabled={isRealTimeEnabled}
      />
    </DriveSyncLayout>
  );
} 